import { FileIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useGeckoAnalytics } from 'features/analytics'
import { useKestrel } from 'features/kestrelViewer'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import { convertMeasurementsToStepFile } from 'features/kestrelViewer/utils/cadExportUtils'

export const DownloadStepFileButton: React.FC = () => {
  const { measurements, kestrelModel } = useKestrel()
  const { trackButtonClicked } = useGeckoAnalytics()

  const handleDownload = () => {
    const stepFileContent = convertMeasurementsToStepFile(measurements)

    const blob = new Blob([stepFileContent], { type: 'application/step' })
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = 'kestrel_measurements.step'
    document.body.appendChild(link)
    link.click()

    document.body.removeChild(link)
    URL.revokeObjectURL(url)

    trackButtonClicked({
      button_name: 'kestrel_download_step_file',
      kestrel_model_id: kestrelModel?.data.kestrel_model_id,
    })
  }

  return (
    <TooltipWrapper side={'top'} offset={5} label={'Download Step File'}>
      <ViewToggle onClick={handleDownload}>
        <FileIcon width={22} height={22} />
      </ViewToggle>
    </TooltipWrapper>
  )
}
